<template>
  <!-- PSG解析結果入力詳細 -->
  <div id="PSGAnalysisOrderDetail">
    <div id="container-center">
      <div class="labelTitle lable">PSG解析 解析結果入力</div>
      <div class="button-area"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td>{{data.receiptNumber}}</td>
            </tr>
            <tr>
              <th>返却希望日</th>
              <td>{{data.returnDate}}</td>
            </tr>
            <tr>
              <th>解析期限</th>
              <td>{{data.analysisDeadline}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receptionNote}}</td>
            </tr>
            <tr v-if="data.rejectHistory && data.rejectHistory.length > 0">
              <th>却下理由</th>
              <td colspan="2">
                <table class="reject-reason-table">
                  <tr>
                    <th class="reject-date">日時</th>
                    <th>理由</th>
                  </tr>
                  <tr v-for="reject in data.rejectHistory" :key="reject.value">
                    <td class="reject-date">{{ reject.completionDate }}</td>
                    <td>{{ reject.reason }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <th>検査日<span class="require"/></th>
              <td><input type="date" style="width:200px" class="edit" name="検査日" validate="required" v-model="data.inspectionDate" :max="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
            </tr>
            <tr>
              <th>AHI<span class="require"/></th>
              <td><input type="text" class="edit" name="AHI" validate="required" v-model="data.ahi" maxlength="256"/></td>
            </tr>
            <tr>
              <th>メモ</th>
              <td><textarea v-model="data.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">アップロードファイル名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><span>{{uploadFileName}}<b-button class="clipbordcopy is-primary" @click="clipboardCopy()">コピーする</b-button></span></td>
            </tr>
            <tr>
              <th>レポートアップロード<span class="require" /></th>
              <td>
                <div class="upload_area" @dragenter="dragEnter">
                  <span class="upload_span">ここに添付する解析データをドラッグアンドドロップするか、「ファイルを追加」を押します。</span>
                </div>
              </td>
              <b-modal :active.sync="isUpdateModal" has-modal-card  >
                <div class="modal-card uploadModal" 
                 @dragleave="dragLeave"
                 @drop.prevent="fileDorop"
                >ここに解析データファイルをドロップします。</div>
              </b-modal>
            </tr>
            <tr>
              <th></th>
              <td>
                <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                  <span class="file-cta">
                    <span class="file-label">ファイルを追加</span>
                  </span>
                </b-upload>                        
              </td>
            </tr>
            <tr><th></th><td>
                <table>
                  <!-- 既にアップロード済み -->
                  <template v-for="(file, index) in preUpFiles">
                    <tr :key="'pre' + index">
                      <td style="width: 20px"><b-icon icon="paperclip" /></td>
                      <td style="width: 400px">{{ file.name }}</td>
                      <td>                    
                        <a @click="deleteUpfile(preUpFiles, index)">
                          <b-icon icon="delete-forever-outline" />
                        </a>
                      </td>
                    </tr>
                  </template>

                  <!-- 新規アップロード -->
                  <template v-for="(file, index) in upFiles">
                    <tr :key="'new' + index">
                      <td style="width: 20px"><b-icon icon="paperclip" /></td>
                      <td style="width: 400px">{{ file.name }}</td>
                      <td>                      
                        <a @click="deleteUpfile(upFiles, index)">
                          <b-icon icon="delete-forever-outline" />
                        </a>
                      </td>
                    </tr>
                  </template>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" v-on:click="approvalRequest">承認依頼</b-button>
        </div>
      </div>
      <div style="height:5px;"/>
      <div class="labelTitle lable">申込内容</div>
      <div id="item-contens">
        <psgRequestDetail  v-if="showDetail" v-bind:data="detailData" :canDownload="true" :belongsNote="data.requestDetails.belongsNote" :isInternalPsg="true" :isClipboardCopy="true" />
      </div>
      <div class="button-area">
        <b-button class="receptionistButton is-primary" v-on:click="save">更新</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
    <b-modal :active.sync="replaceReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="replacement" v-bind:title="'データ差し替え(再アップロード依頼理由入力)'"></reasonInputModal>
    </b-modal>
  </div>
</template>

<script>
import psgRequestDetail from "@/components/mock/common/PSGRequestDetail";
import {UploadType} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
export default {
  name: "PSGAnalysisOrderDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "PSGAnalysisOrder",
        params: { searchConditions: this.searchParams },
      });
    },
    replacement: async function(reason) {
      this.replacementReason = reason
      // データ差し替え依頼
      var excuteApi = this.setAnalysisReplacementPOST;
      var successCallBack = this.setAnalysisReplacementPOSTSuccess;
      var errorCallBack = this.setAnalysisReplacementPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setAnalysisReplacementPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.reason = this.replacementReason
      obj.isReport = false
      delete obj.requestDetails
      return client.apis.externalAnalysis.setAnalysisReplacementPOST({
        body:obj
      });
    },
    setAnalysisReplacementPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setAnalysisReplacementPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    approvalRequest: async function() {
      var errMsg = ""
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError) {
        errMsg = result.msg
      }
      if (this.upFiles.length === 0 && this.preUpFiles.length === 0) {
        errMsg = errMsg + "解析レポートファイルは必須項目です。"
      } else{
        let preNameList = this.preUpFiles.map(item => this.getUploadFileName(item));
        let nameList = this.upFiles.map(item => this.getUploadFileName(item));
        nameList = nameList.concat(preNameList);
        for(let i = 0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            let zipName = nameList[i].replace("/", "");
            nameList[i] = zipName + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          errMsg = errMsg + "解析レポートの重複しているファイルが存在します。\n"
        }
        let targetFile = this.upFiles;
        let okSize = await this.checkUploadFileSize(targetFile);
        if(!okSize){
          errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
        }
      }
      if(errMsg) {
        this.showErrorMessage(errMsg)
        return
      }

      // アップロードファイル名チェック
      if(!this.checkUploadFileName(this.preUpFiles.concat(this.upFiles))){
        return
      }
      //まずはファイルのアップロード
      this.multipleUpload(this.upFiles ,this.receiptNumber, this.UploadType.psg_report).then(result => {
        this.uploadSuccessFile = result;
        var excuteApi = this.setAnalysisApprovalRequestPOST;
        var successCallBack = this.setAnalysisApprovalRequestPOSTSuccess;
        var errorCallBack = this.setAnalysisApprovalRequestPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }).catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
      });
    },
    setAnalysisApprovalRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.analysisResultFileList = [
        ...this.preUpFiles,
        ...this.uploadSuccessFile.map(f => ({
          fileId: 0,
          name: f.fileName,
          fileAddress: f.filePath
        }))
      ];
      obj.isReport = false
      return client.apis.externalAnalysis.setAnalysisApprovalRequestPOST({
        body:obj
      });
    },
    setAnalysisApprovalRequestPOSTSuccess: function(result) {
      this.$dialog.alert({title: '　',message: "登録しました。"})
      this.back()
    },
    setAnalysisApprovalRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getDetail: function() {
      var excuteApi = this.getAnalysisDetailPOST;
      var successCallBack = this.getAnalysisDetailPOSTSuccess;
      var errorCallBack = this.getAnalysisDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{receiptNumber:this.receiptNumber}
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.preUpFiles = (this.data.analysisResultFileList || []).map(f => ({
        fileId: f.fileId,
        name: f.name,
        fileAddress: f.fileAddress
      }));
      this.upFiles = [];
      this.detailData = this.data.requestDetails
      this.showDetail = true;
      this.uploadFileName = this.detailData.patientId + "_" + this.data.requestDate + "_" + this.data.uploadFileName + "_" + this.data.patientName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')
      console.log(this.detailData)
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      console.log("dragLeave")
      this.isUpdateModal = false;
    },
    fileDorop: function(event) {
      console.log("fileDorop")
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        this.upFiles.push({
          file: entry,
          name: entry.name
        });
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.upFiles.push({
          file: upFile,
          name: upFile.name
        });
      }
      this.upButtonFile = [];
    },   
    deleteUpfile: function(list, index) {
      list.splice(index, 1);
    },
    save: async function () {
      // 更新処理
      var errMsg = ""
      if (this.upFiles.length!=0 || this.preUpFiles.length != 0) {
        let preNameList = this.preUpFiles.map(item => this.getUploadFileName(item));
        let nameList = this.upFiles.map(item => this.getUploadFileName(item));
        nameList = nameList.concat(preNameList);
        for(let i = 0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            let zipName = nameList[i].replace("/", "");
            nameList[i] = zipName + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          errMsg = errMsg + "解析レポートの重複しているファイルが存在します。\n"
        }
        let targetFile = this.upFiles;
        let okSize = await this.checkUploadFileSize(targetFile);
        if(!okSize){
          errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
        }
      }
      if(errMsg) {
        this.showErrorMessage(errMsg)
        return
      }
      //ファイルアップロード
      this.multipleUpload(this.upFiles ,this.receiptNumber, this.UploadType.psg_report).then(result => {
        this.uploadSuccessFile = result;
        var excuteApi = this.setPsgContentsUpdatePOST;
        var successCallBack = this.setPsgContentsUpdatePOSTSuccess;
        var errorCallBack = this.setPsgContentsUpdatePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      })
      .catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
      });
    },
    setPsgContentsUpdatePOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber, // 申込みID
        version: this.data.version, // バージョン
        viewType:"解析結果入力",
        inspectionDate: this.data.inspectionDate ? this.data.inspectionDate.replace(/-/g, "/") : "", // 検査日
        ahi:this.data.ahi, // AHI
        analysisResultNote: this.data.memo,  // 解析結果入力備考
      });    
      obj.analysisResultFileList = [
        ...this.preUpFiles,
        ...this.uploadSuccessFile.map(f => ({
          fileId: 0,
          name: f.fileName,
          fileAddress: f.filePath
        }))
      ];
      obj.isReport = false
      return client.apis.externalAnalysis.setPsgContentsUpdatePOST({
        body:obj
      });
    },
    setPsgContentsUpdatePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.showDetail = false;
      this.getDetail()
    },
    setPsgContentsUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    clipboardCopy: function(){
      navigator.clipboard.writeText(this.uploadFileName).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    },
    getUploadFileName: function(uploadItemIfno) {
      if(!uploadItemIfno){
        return ""
      }
      return uploadItemIfno.path || uploadItemIfno.name || (uploadItemIfno.file ? uploadItemIfno.file.name : "")
    },
    checkUploadFileName: function(files) {
      for(let uploadItemIfno of files){
        var name = this.getUploadFileName(uploadItemIfno)
        if(name.indexOf(".") != -1 && name.indexOf(this.uploadFileName) == -1){
          this.showErrorMessage("添付したファイルの診察券ID、申込日、医療機関名、患者名が正しくない可能性があります。")
          return false
        }
      }
      return true
    },
  },
  data() {
    var receiptNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var data = {};
    var detailData = {analysisDataInfo:{attachedDataFileList:{}}}
    return {
      UploadType:UploadType,
      receiptNumber,
      data,
      detailData,
      searchParams,
      isUpdateModal: false,
      showDetail: false,
      upButtonFile:null,
      upFiles: [],
      preUpFiles: [],
      uploadSuccessFile: [],
      replaceReasonInputModalActive:false,
      replacementReason:"",
      uploadFileName:"",
    };
  },
  filters: {},
  components: {
    reasonInputModal:reasonInputModal,
    psgRequestDetail:psgRequestDetail
  },
  mounted: function() {
    // 詳細情報取得
    this.getDetail()
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    font-weight: bold; 
}
.delay ,
.error {
    color: red;
    margin-left:5px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
table.reject-reason-table {
  border-collapse: collapse;
  table-layout: fixed;
}
table.reject-reason-table th,
table.reject-reason-table tr,
table.reject-reason-table td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.reject-reason-table td {
  padding-left: 10px;
}
table.reject-reason-table th {
  text-align: center;
}
.reject-reason-table th.reject-date,
.reject-reason-table td.reject-date {
  width: 20% !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/PSGAnalysisOrderDetail.vue